import React, { useState, useEffect } from 'react';

interface LoadingSpinnerProps {
  size?: 'sm' | 'md' | 'lg';
  className?: string;
  showTimer?: boolean;
  message?: string;
}

export const LoadingSpinner: React.FC<LoadingSpinnerProps> = ({
  size = 'md',
  className = '',
  showTimer = false,
  message
}) => {
  const [elapsedTime, setElapsedTime] = useState(0);

  useEffect(() => {
    if (!showTimer) {
      return undefined;
    }

    const startTime = Date.now();
    const interval = setInterval(() => {
      setElapsedTime(Date.now() - startTime);
    }, 100);

    return () => clearInterval(interval);
  }, [showTimer]);

  const sizeClasses = {
    sm: 'w-4 h-4',
    md: 'w-8 h-8',
    lg: 'w-12 h-12',
  };

  const formatTime = (ms: number): string => `${(ms / 1000).toFixed(1)}s`;

  return (
    <div className={`flex flex-col items-center justify-center gap-3 ${className}`}>
      <div
        className={`${sizeClasses[size]} border-4 border-blue-200 border-t-blue-600 rounded-full animate-spin`}
      />
      {message && (
        <p className="text-sm text-gray-600">{message}</p>
      )}
      {showTimer && (
        <p className="text-sm font-mono text-blue-600 font-semibold">
          {formatTime(elapsedTime)}
        </p>
      )}
    </div>
  );
};

export const LoadingPage: React.FC<{ message?: string; showTimer?: boolean }> = ({
  message = 'Loading...',
  showTimer = false
}) => {
  return (
    <div className="min-h-screen flex items-center justify-center bg-gray-50">
      <LoadingSpinner size="lg" message={message} showTimer={showTimer} />
    </div>
  );
};
